export async function getUa() {
  const { UAParser } = await import('ua-parser-js')
  return new UAParser()
}
